var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "server"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0449 2.39443L3.04492 2.39626C2.21649 2.39638 1.54502 3.06806 1.54515 3.89648L1.54561 6.89648C1.54573 7.72491 2.21741 8.39638 3.04584 8.39626L15.0458 8.39443C15.8743 8.3943 16.5457 7.72263 16.5456 6.8942L16.5452 3.8942C16.545 3.06577 15.8733 2.3943 15.0449 2.39443Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0469 11.3944L3.04688 11.3963C2.21845 11.3964 1.54698 12.0681 1.5471 12.8965L1.54756 15.8965C1.54769 16.7249 2.21936 17.3964 3.04779 17.3963L15.0478 17.3944C15.8762 17.3943 16.5477 16.7226 16.5476 15.8942L16.5471 12.8942C16.547 12.0658 15.8753 11.3943 15.0469 11.3944Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.54492 5.39551L4.55212 5.39551",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.54688 14.3955L4.55408 14.3955",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.0d4393bd6a7b6a29fd1d28e908999f10.svg";
export { ForwardRef as ReactComponent };